import { ChevronLeft, Settings2, SparkleIcon } from "lucide-react"
import { MegaphoneIcon } from '@phosphor-icons/react';
import { Button } from "@/components/ui/button"
import { useNavigate } from "react-router-dom"
import { Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useAuth } from "@/context/AuthContext"

interface PageHeaderProps {
    title?: string;
    titleKey?: string;
    onBackClick?: () => void;
    displayBackButton?: boolean;
}

export default function PageHeader({ title, titleKey, onBackClick, displayBackButton = true }: PageHeaderProps) {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { user } = useAuth()
    const onBackClicked = () => {
        navigate(-1)
    }
    const credits = user?.credits ?? 0;
    const displayTitle = titleKey ? t(titleKey) : title
    return (
        <>
            <header className="bg-[#F5F3F0] text-theme-dark flex items-center fixed left-0 right-0 z-50 border-b border-[#2B2E4A] px-4 h-[64px]">
                <div className="flex items-center flex-1 pt-0">
                    {displayBackButton && (
                        <Button
                            variant="ghost"
                            size="icon"
                            className="mr-3 hidden md:block"
                            onClick={onBackClick || onBackClicked}
                        >
                            <ChevronLeft className="h-5 w-5" />
                        </Button>
                    )}
                    {!displayBackButton && (
                        <div className="w-13 mr-3"></div>
                    )}
                    <div className="flex-1">
                        <Typography
                            variant="h2"
                            component="h2"
                            sx={{
                                color: "#2B2E4A",
                                margin: 0
                            }}
                        >
                            {displayTitle}
                        </Typography>
                    </div>
                    {location.pathname === "/spread-cards" && <div id="credits" className="mr-3 pt-1"
                        style={{
                            color: '#C8A84E',
                            textShadow: '0 0 3px rgba(255, 255, 255, 0.8)',
                            fontSize: '0.95rem',
                            fontWeight: '500',
                            minWidth: '40px',
                        }}
                    >
                        <span className="flex items-center gap-1 "><span
                            className="flex items-center gap-1 text-[#6C5840]"
                        >{credits}</span> <SparkleIcon size={16} color="rgba(213, 183, 107, 0.9)" /></span>

                    </div>}
                </div>
            </header>
        </>
    )
}
